import React, { Component } from 'react'
import classnames from 'classnames'
import './collection-row-titles.css'

class CollectionRowTitles extends Component {

  constructor(props) {
    super(props)
    this.state = {
      aboveViewport: false 
    }
    this.aboveViewport = false
    this.tickInterval = 300
  }

  componentDidMount() {
    this.getRect()
    if (this.props.single) this.startTick()
  }

  componentDidUpdate(prevProps) {
    this.getRect()
  }

  componentWillUnmount() {
    this.cancelTick()
  }

  startTick() {
    if (!this.tickTimeout) {
      this.tickTimeout = setTimeout(this.tick, this.tickInterval)
    }
  }

  cancelTick() {
    clearTimeout(this.tickTimeout)
    this.tickTimeout = null
  }


  tick = () => {
    const { st } = this.props

    this.getRect()

    // element above
    const bufferHeight = 200
    const elementAbove = this.y1 < st + bufferHeight

    const aboveViewport = elementAbove // && !elementBelow

    // if viewport change, set state 
    if (aboveViewport !== this.aboveViewport) {
      this.aboveViewport = aboveViewport

      this.setState({
        aboveViewport
      })
    }

    this.tickTimeout = setTimeout(this.tick, this.tickInterval)
  }


  getRect() {
    const { st } = this.props 
    const rect = this.el.getBoundingClientRect()

    const y0 = rect.top + st
    const y1 = y0 + rect.height

    // y0 represents y position of element top in document
    // ie. if at 0, always will be a 0 wherever you scroll
    this.y0 = y0
    // y1 represent y position of element bottom 
    this.y1 = y1
    this.height = rect.height
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.single !== this.props.single) return true
    if (nextProps.title !== this.props.title) return true
    if (nextProps.subtitle !== this.props.subtitle) return true
    if (nextState.aboveViewport !== this.state.aboveViewport) return true
    return false
  }

  render() {
    const {
      single, 
      title, 
      subtitle,
      vh,
    } = this.props 

    const {
      aboveViewport
    } = this.state

    return (
      <div 
        ref={el => this.el = el}
        style={{ top: (vh / 2 - (this.height || 80) / 2) }}
        className={classnames({
          'collection__row-titles--above-viewport': aboveViewport,
          'collection__row-titles--single': single,
          }, 'collection__row-titles')}>
        {!single &&
        <div className="collection__row-title text--small-serif">
          {title}
        </div>
        }
        <div dangerouslySetInnerHTML={{ __html: subtitle }} className="collection__row-subtitle text--small"></div>
      </div>
    )
  }
}

export default CollectionRowTitles



// WEBPACK FOOTER //
// ./src/components/collection-row-titles/index.js